import { Tool } from '@services/tools';

export class CardTool extends Tool {
  constructor(text: string, executor: (cardId: string) => void) {
    super(text, '', '', 0, cardId => executor(cardId));
  }
}

export class CardToolsGroup {
  get name(): string {
    return this._name;
  }

  get priority(): number {
    return this._priority;
  }

  private _tools: CardTool[] = [];
  get tools(): CardTool[] {
    return this._tools;
  }

  constructor(private _name: string, private _priority: number) {}
}
